import { render, staticRenderFns } from "./AdActiveAdmin.vue?vue&type=template&id=1d44dcab&scoped=true&"
import script from "./AdActiveAdmin.vue?vue&type=script&lang=js&"
export * from "./AdActiveAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d44dcab",
  null
  
)

export default component.exports